export default __webpack_public_path__ + "static/media/tek-logo.b32e0434.svg";